import Vue from 'vue'
import Vuex from 'vuex'
import EventBus from '../eventbus'
import { make } from 'vuex-pathify'
import pathify from '../config/store.pathify'

// Modules
import auth from './modules/store.auth'

Vue.use(Vuex)

const namespaced = true
const modules = { auth }
const plugins = [ pathify.plugin ]
const strict = process.env.NODE_ENV !== 'production'

const state = {
  user: null,
  userGroups: null,
  userAttributes: Object,
  loaded: false,
  authenticated: false
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),

  load (context) {
    // ---- These events are emitted once the listed module is loaded ----- //
    // Loads the vuex "es" module (Elastic Search) [MUST BE AFTER AUTH]
    // EventBus.$on('auth/loaded', () => context.dispatch('es/load'))
    EventBus.$on('auth/loaded', () => context.dispatch('es/load'))
  }
}

const getters = make.getters(state)

export const store = new Vuex.Store({
  state,
  strict,
  plugins,
  actions,
  modules,
  getters,
  mutations,
  namespaced
})



// WEBPACK FOOTER //
// ./src/store/index.js